import {DELETE_CDC_CARD_START} from "../../types";

export const delete_card_category = (payload) => ({
    type: DELETE_CDC_CARD_START,
    payload,
});
